import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type {
  Martailer,
  MartailerPlacement
} from '@schibsted-nmp/advertising-shared';

type MartailerAtom = {
  placements: Array<MartailerPlacement>;
  config: Martailer | null;
};

export const $martailerAtom = atom<$martailerAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.Martailer,
  {
    placements: [],
    config: null
  }
);

export namespace $martailerAtom {
  export type Value = MartailerAtom;
}
